import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@qodo/design-system';
import { useLocalStorage } from 'usehooks-ts';
import { getPostOnboardingDestination } from '../../components/GithubPublicAppInstallationDialog/utils';
import { LogoHeader } from '../../components/Sidebar/parts/LogoHeader';
import { LOCAL_STORAGE_KEYS } from '../../consts/localStorage';
import { AnimatedWizardOutlet } from './parts/AnimatedWizardOutlet';

export const OnboardingWizard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, setHasCompletedOnboarding] = useLocalStorage(
    LOCAL_STORAGE_KEYS.ONBOARDING_WIZARD_COMPLETED,
    false,
  );

  const onContinueClick = () => {
    setHasCompletedOnboarding(true);
    navigate(getPostOnboardingDestination());
  };

  return (
    <div className="h-screen bg-app-background overflow-x-hidden">
      <LogoHeader />
      <main className="flex items-center justify-center pb-20 w-full h-[calc(100vh_-_var(--onboarding-header-height)_-_2*var(--onboarding-header-vertical-padding))]">
        <div className="flex flex-col gap-12 items-start">
          <AnimatedWizardOutlet />
          <Button
            variant="secondary"
            onClick={onContinueClick}
            className="gap-1.5"
          >
            {t('general.done')}
          </Button>
        </div>
      </main>
    </div>
  );
};
